import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

import { SHORTLIST_FOOTER_CTA_LABEL } from '@/modules/public-shortlist/constants';
import {
  getShortlistRevealInitial,
  getShortlistRevealTransition,
  shortlistRevealVisible,
} from '@/modules/public-shortlist/shortlistMotion';
import { Button } from '@/modules/ui/components/button/Button';

interface ShortlistCtaProps {
  onCtaClick: () => void;
  title?: string;
  description?: string;
}

export function ShortlistCta({
  onCtaClick,
  title = 'Ready to meet someone from this list?',
  description = "Tell us who caught your eye and we'll coordinate warm introductions.",
}: ShortlistCtaProps) {
  const prefersReducedMotion = useReducedMotion();

  return (
    <motion.section
      aria-labelledby="shortlist-cta-heading"
      initial={getShortlistRevealInitial(prefersReducedMotion)}
      whileInView={shortlistRevealVisible}
      viewport={{ once: true, amount: 0.35 }}
      transition={getShortlistRevealTransition(prefersReducedMotion)}
      className="bg-primary-700 rounded-2xl px-6 py-8 text-center text-white sm:px-10 sm:py-10"
    >
      <h2
        id="shortlist-cta-heading"
        className="mx-auto max-w-md text-xl font-semibold tracking-tight text-balance sm:text-2xl"
      >
        {title}
      </h2>
      <p className="mx-auto mt-4 max-w-md text-base leading-relaxed font-normal text-pretty text-white/80">
        {description}
      </p>

      <Button
        size="lg"
        className="text-primary-700 mt-8 bg-white font-semibold hover:bg-white/90"
        onClick={onCtaClick}
      >
        {SHORTLIST_FOOTER_CTA_LABEL}
        <ArrowRight className="size-4" aria-hidden />
      </Button>
    </motion.section>
  );
}
